// Utility function to download a blob as a file
export const downloadBlob = (blob: Blob, fileName: string) => {
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  window.URL.revokeObjectURL(url)
  document.body.removeChild(a)
}

// Build query string from filter object
export const buildExportQuery = (filters: {
  search?: string
  status?: string
  fromDate?: string
  toDate?: string
}) => {
  const params = new URLSearchParams()

  if (filters.search?.trim()) {
    params.set('search', filters.search.trim())
  }
  if (filters.status) {
    params.set('status', filters.status)
  }
  if (filters.fromDate) {
    params.set('fromDate', filters.fromDate)
  }
  if (filters.toDate) {
    params.set('toDate', filters.toDate)
  }

  return params.toString()
}
